import metaClient from './meta-client';

export type IceBreakerScope = 'page' | 'category';
export type IceBreakerActionType = 'flow' | 'postback';
export type IceBreakerSyncStatus = 'pending' | 'synced' | 'partial' | 'error';

export interface IceBreakerQuestion {
    question: string;       // max 80 chars
    payload: string;        // max 1000 chars
    action_type: IceBreakerActionType;
    flow_id?: number | null;
}

export interface IceBreakerRow {
    id: number;
    user_id: number;
    scope: IceBreakerScope;
    page_id?: string | null;
    page_name?: string | null;
    category_id?: number | null;
    category_name?: string | null;
    questions: IceBreakerQuestion[];
    locale: string;
    is_active: boolean;
    sync_status: IceBreakerSyncStatus;
    last_synced_at?: string | null;
    sync_error?: string | null;
    affected_pages_count: number;
    created_at?: string;
    updated_at?: string;
}

export interface IceBreakerCreatePayload {
    scope: IceBreakerScope;
    page_id?: string;
    category_id?: number;
    questions: IceBreakerQuestion[];
    locale?: string;
    is_active?: boolean;
}

export interface IceBreakerUpdatePayload {
    questions?: IceBreakerQuestion[];
    locale?: string;
    is_active?: boolean;
}

const PREFIX = '/meta/ice-breakers';

export const listIceBreakers = async (): Promise<IceBreakerRow[]> => {
    const r = await metaClient.get<IceBreakerRow[]>(PREFIX);
    return r.data;
};

export const getIceBreaker = async (id: number): Promise<IceBreakerRow> => {
    const r = await metaClient.get<IceBreakerRow>(`${PREFIX}/${id}`);
    return r.data;
};

export const createIceBreaker = async (payload: IceBreakerCreatePayload): Promise<IceBreakerRow> => {
    const r = await metaClient.post<IceBreakerRow>(PREFIX, payload);
    return r.data;
};

export const updateIceBreaker = async (id: number, payload: IceBreakerUpdatePayload): Promise<IceBreakerRow> => {
    const r = await metaClient.patch<IceBreakerRow>(`${PREFIX}/${id}`, payload);
    return r.data;
};

export const deleteIceBreaker = async (id: number): Promise<{ message: string }> => {
    const r = await metaClient.delete<{ message: string }>(`${PREFIX}/${id}`);
    return r.data;
};

export const resyncIceBreaker = async (id: number): Promise<IceBreakerRow> => {
    const r = await metaClient.post<IceBreakerRow>(`${PREFIX}/${id}/sync`);
    return r.data;
};

export interface FlowTrigger {
    trigger_id: number;
    node_id: number;
    trigger_type: 'keyword' | 'tag' | 'exact_match' | 'contains' | 'default';
    trigger_value: string;
    funnel_id: number;
    funnel_name: string;
}

export const listFlowTriggers = async (): Promise<FlowTrigger[]> => {
    const r = await metaClient.get<FlowTrigger[]>(`${PREFIX}/available-triggers`);
    return r.data;
};
